import { ModalName } from '@/constants/modals';
import i18n from '@/i18n';
import { MissionCommand } from '@/types/mission';

import {
	type DropdownGeneratorAction,
	DropdownGeneratorActionType,
	DropdownItemColors,
} from '@/dsComponents/Dropdown/types';

export const actionList: (DropdownGeneratorAction & {
	commandName?: MissionCommand;
	modalName?: ModalName;
	// biome-ignore lint/suspicious/noExplicitAny: Init Biome
	modalProps?: any;
})[] = [
	{
		commandName: MissionCommand.show,
		modalName: ModalName.MissionDetails,
		type: DropdownGeneratorActionType.item,
		item: {
			label: i18n.global.t('global.details'),
			iconLeft: 'file-search',
		},
	},
	{
		commandName: MissionCommand.complete,
		type: DropdownGeneratorActionType.item,
		modalProps: {
			// openAfterCloseOrder: true,
		},
		item: {
			label: i18n.global.t('page.mission.kanbanListActions.closeMission'),
			iconLeft: 'circle-check',
		},
	},
	{
		commandName: MissionCommand.sendOrderToEvolia,
		modalName: ModalName.SendOrderToEvolia,
		type: DropdownGeneratorActionType.item,
		item: {
			label: i18n.global.t('page.mission.kanbanListActions.sendToEvolia'),
			iconLeft: 'cloud-up',
		},
	},
	{
		commandName: MissionCommand.archive,
		type: DropdownGeneratorActionType.item,
		item: {
			label: i18n.global.t('global.actions.archive'),
			iconLeft: 'archive',
		},
	},
	{ type: DropdownGeneratorActionType.separator },
	{
		commandName: MissionCommand.cancel,
		modalName: ModalName.CancelMissionLegacy,
		type: DropdownGeneratorActionType.item,
		item: {
			label: i18n.global.t('global.actions.cancel'),
			iconLeft: 'package-off',
			labelColor: DropdownItemColors.red,
			iconLeftColor: DropdownItemColors.red,
		},
	},
];
